import styled from "styled-components";

export const CancelButtonWrapper = styled.path`
  fill: #FD2020;

  &:hover {
    fill: #981313;
  }
`;